import React from 'react';

interface PaymentDonutProps {
  percent: number;
  tone?: 'default' | 'success' | 'danger';
  className?: string;
}

const PaymentDonut: React.FC<PaymentDonutProps> = ({ percent, tone = 'default', className = '' }) => {
  const clamped = Math.max(0, Math.min(100, Math.round(percent)));
  const r = 14;
  const c = 2 * Math.PI * r;
  const offset = c - (clamped / 100) * c;

  const strokeClass =
    tone === 'danger'
      ? 'task-detail__donut-progress--danger'
      : tone === 'success'
        ? 'task-detail__donut-progress--success'
        : 'task-detail__donut-progress--default';

  const wrapClass = [
    'task-detail__donut-wrap',
    tone === 'danger' ? 'task-detail__donut-wrap--danger' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={wrapClass} aria-hidden>
      <svg className="task-detail__donut" viewBox="0 0 36 36">
        <circle cx="18" cy="18" r={r} fill="none" stroke="var(--portal-border-finance)" strokeWidth="4" />
        <circle
          className={strokeClass}
          cx="18"
          cy="18"
          r={r}
          fill="none"
          strokeWidth="4"
          strokeDasharray={c}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      <span className="task-detail__donut-label">{clamped}%</span>
    </div>
  );
};

export default PaymentDonut;
